import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

function formatMetricValue(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return value;
  return Number.isInteger(n) ? n : Math.round(n * 100) / 100;
}

export function buildTournamentExportFilename(stats) {
  const tag = (stats?.campaign_name || `campaign-${stats?.campaign_id || 'export'}`)
    .replace(/[^\w.-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  const date = dayjs(stats?.exported_at).format('YYYY-MM-DD');
  return `${tag}-tournament-stats-${date}.xlsx`;
}

export function buildActiveDealersExportFilename(data) {
  const tag = (data?.campaign_name || `campaign-${data?.campaign_id || 'export'}`)
    .replace(/[^\w.-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  const date = dayjs(data?.exported_at).format('YYYY-MM-DD');
  return `${tag}-active-dealers-${date}.xlsx`;
}

function buildDealerExportSheet(dealers, value1Header, includeLastLogin) {
  const headers = includeLastLogin
    ? [value1Header, 'Points', 'Dealer Name', 'Team Name', 'Email', 'Last Login']
    : [value1Header, 'Points', 'Dealer Name', 'Team Name', 'Email'];

  const rows = (dealers || []).map((dealer) => {
    const base = [
      formatMetricValue(dealer.value_1),
      formatMetricValue(dealer.points),
      dealer.dealer_name || '',
      dealer.team_name || '',
      dealer.email || '',
    ];
    if (includeLastLogin) {
      base.push(dealer.last_login ? dayjs(dealer.last_login).format('YYYY-MM-DD HH:mm') : '');
    }
    return base;
  });

  const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  sheet['!cols'] = includeLastLogin
    ? [{ wch: 14 }, { wch: 10 }, { wch: 28 }, { wch: 24 }, { wch: 32 }, { wch: 18 }]
    : [{ wch: 14 }, { wch: 10 }, { wch: 28 }, { wch: 24 }, { wch: 32 }];
  return sheet;
}

export function downloadActiveDealersExportExcel(data) {
  const value1Header = data?.value_1_label || 'Value 1';
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    buildDealerExportSheet(data?.active_dealers, value1Header, true),
    'Active Dealers'
  );
  XLSX.utils.book_append_sheet(
    workbook,
    buildDealerExportSheet(data?.inactive_dealers, value1Header, false),
    'Inactive Dealers'
  );
  XLSX.writeFile(workbook, buildActiveDealersExportFilename(data));
}

export function downloadTournamentExportExcel(stats) {
  const exportedAt = stats?.exported_at
    ? dayjs(stats.exported_at).format('YYYY-MM-DD HH:mm')
    : dayjs().format('YYYY-MM-DD HH:mm');

  const rows = [
    ['Campaign', stats?.campaign_name || ''],
    ['Exported at', exportedAt],
    [],
    ['Metric', 'Value'],
    ...(stats?.metrics || []).map((m) => [m.label, formatMetricValue(m.value)]),
  ];

  const sheet = XLSX.utils.aoa_to_sheet(rows);
  sheet['!cols'] = [{ wch: 42 }, { wch: 16 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Campaign Stats');
  XLSX.writeFile(workbook, buildTournamentExportFilename(stats));
}
